module.exports = __webpack_public_path__ + "static/media/contacts.ef514fc8.svg";